module.exports = __webpack_public_path__ + "static/media/07.5cd79609.mp3";